import { Pipe, PipeTransform } from '@angular/core';
import { DateArg, differenceInSeconds } from 'date-fns';
import { divmod } from '../utils/math';

@Pipe({
  name: 'formatInterval',
})
export class FormatIntervalPipe implements PipeTransform {
  transform(laterDate: DateArg<Date>, earlierDate: DateArg<Date>): unknown {
    const _laterDate = new Date(laterDate);
    const _earlierDate = new Date(earlierDate);

    const totalSeconds = Math.abs(differenceInSeconds(_laterDate, _earlierDate));

    const [days, remainderAfterDays] = divmod(totalSeconds, 86400);
    const [hours, remainderAfterHours] = divmod(remainderAfterDays, 3600);
    const [minutes, seconds] = divmod(remainderAfterHours, 60);

    return `${days}d ${hours}h ${minutes}m ${seconds}s`;
  }
}
